/** Maps keys to KeyboardActions. The keys correspond to the event.code property.
 ** See https://keycode.info/ for codes for specific keys
 ** This is configurable in state.input.keyMap
 **/
export const DefaultKeyMap = {
  Space: 'PLAYER_PAUSE',
  ArrowUp: 'ZOOM_IN',
  ArrowDown: 'ZOOM_OUT',
};

export const DebugKeyMap = {
  ...DefaultKeyMap,
  KeyL: 'TOGGLE_LABELS',
  KeyM: 'TOGGLE_MINI_UI',
  KeyN: 'TOGGLE_HIDE_UI',
  KeyK: 'CLEAR_TILES',
  KeyS: 'SAVE_STATE',
  KeyD: 'UNLOAD_STATE',
  KeyT: 'TOGGLE_GLOBE',
};

/** All the potential actions that can be triggered by a keypress.
 ** The keys that trigger these actions can be checked in state.input.keyMap
 **/
export const KeyboardActions = {
  PLAYER_PAUSE: app => app.store.dispatch({ type: 'TOGGLE_PLAYING' }),
  ZOOM_IN: app => app.store.dispatch({ type: 'CAMERA_ZOOM_IN' }),
  ZOOM_OUT: app => app.store.dispatch({ type: 'CAMERA_ZOOM_OUT' }),

  // Development
  TOGGLE_LABELS: app => app.store.dispatch({ type: 'TOGGLE_LABELS' }),
  TOGGLE_MINI_UI: app => app.store.dispatch({ type: 'TOGGLE_MINI_UI' }),
  TOGGLE_HIDE_UI: app => app.store.dispatch({ type: 'TOGGLE_HIDE_UI' }),
  CLEAR_TILES: app => app.globe.tileManager.clearTiles(),
  SAVE_STATE: () => window.AyvriViewerDebug.state.save(),
  UNLOAD_STATE: () => window.AyvriViewerDebug.state.unload(),
  TOGGLE_GLOBE: app => app.globes[1].toggleVisible(),
};
